import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { InvitationAccept } from "@/features/invitations/accept";

const invitationSchema = z.object({});

export const Route = createFileRoute("/invitations/accept")({
  component: InvitationAccept,
  validateSearch: invitationSchema,
});
